'use strict';

import register from './core';
import '../functions/jquery-global.js';
import waypoints from 'waypoints/lib/jquery.waypoints';
import sticky from 'waypoints/lib/shortcuts/sticky';

register('breadcrumbs', function (element) {

  if (element.classList.contains('studentsite')) {
    var studentClass = element.classList[1]
    sticky = new Waypoint.Sticky({
      stuckClass: studentClass + '--stuck',
      element: element,
      wrapper: '<div class="sticky-wrapper--breadcrumbs" />'
    })
  }

  else if (element.classList.contains('staffsite')) {
    var staffClass = element.classList[1]
    sticky = new Waypoint.Sticky({
      stuckClass: staffClass + '--stuck',
      element: element,
      wrapper: '<div class="sticky-wrapper--breadcrumbs" />'
    })
  }

  else {
    var blockClass = element.classList[0],
    sticky = new Waypoint.Sticky({
      stuckClass: blockClass + '--stuck',
      element: element,
      wrapper: '<div class="sticky-wrapper--breadcrumbs" />'
    })
  }

  //NOTE: Make sure that all waypoints are enabled
  setTimeout(function () {
    Waypoint.enableAll();
  }, 0);
});
